import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export type IKVKeyType = number | string;

export interface IKVStorage {
    getItem: (key: IKVKeyType) => Promise<unknown>;
    getBoolean: (key: IKVKeyType) => Promise<boolean>;
    getString: (key: IKVKeyType) => Promise<string>;
    setItem: (key: IKVKeyType, value: unknown) => Promise<void>;
    removeItem: (key: number | string) => Promise<void>;
    clear: () => Promise<void>;
    length: () => Promise<number>;
}

export function injectKVStorage(container: IContainer = injectOrBuildContainer()): IKVStorage {
    return container.get<IKVStorage>(TYPES.IKVStorage);
}

export function bindKVStorage(
    val: IKVStorage,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IKVStorage>(TYPES.IKVStorage, val);
}

export function unbindKVStorage(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IKVStorage);
}
